import { Switch } from 'react-router-dom';
import { useModuleFeatureFlag } from '@/providers/FeatureFlag.provider';
import ProtectedRoute from '../../utils/ProtectedRoute';
import Settings from './Settings/Settings';
import Webhooks from './Webhooks/Webhooks';
import UpdateWebhookContainer from './Webhooks/UpdateWebhooks/UpdateWebhooksContainer';
import WebhooksHistoryContainer from './Webhooks/WebhookHistory/WebhooksHistoryContainer';
import AuthorizedIps from './AuthorizedIps/AuthorizedIps';
import UpdateAuthorizedIpsContainer from './AuthorizedIps/UpdateAuthorizedIps/UpdateAuthorizedIpsContainer';
import BrandingSettings from './BrandingSettings/BrandingSettings';
import ElinxSettingsPage from './ELinx/ElinxSettingsPage';
import DomainSetup from './DomainSetup';
import PreFundingSettings from './PreFundingSettings/PreFundingSettings';
import { useLockedFeatures } from '../../providers/LockedFeatures.provider';
import { usePermissions } from '../../providers/Permissions.provider';
import usePreFundingEnabled from '@/hooks/usePreFundingEnabled';
import { JSX } from 'react';

const Routes = (): JSX.Element => {
  const lockedFeatures = useLockedFeatures();
  const featureFlags = useModuleFeatureFlag('settings');
  const { permissions } = usePermissions();
  const preFundingEnabled = usePreFundingEnabled();

  return (
    <Switch>
      <ProtectedRoute isAllowed={featureFlags.isEnabled} showPermission exact path="/settings" component={Settings} />
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled}
        showPermission
        exact
        path="/settings/webhooks/history"
        component={WebhooksHistoryContainer}
      />
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled}
        showPermission
        exact
        path="/settings/webhooks/update"
        component={UpdateWebhookContainer}
      />
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled}
        showPermission
        exact
        path="/settings/webhooks"
        component={Webhooks}
      />
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled}
        showPermission
        exact
        path="/settings/authorized-ips"
        component={AuthorizedIps}
      />
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled}
        showPermission
        exact
        path="/settings/authorized-ips/update"
        component={UpdateAuthorizedIpsContainer}
      />
      <ProtectedRoute
        isAllowed={featureFlags.isEnabled}
        showPermission
        path="/settings/domain-setup"
        component={DomainSetup}
      />

      <ProtectedRoute
        isAllowed={
          (!!lockedFeatures.BrandingELinxEnabled ||
            !!lockedFeatures.BrandingEmailEnabled ||
            !!lockedFeatures.BrandingOnboardingEnabled ||
            !!lockedFeatures.BrandingPortalEnabled) &&
          featureFlags.isEnabled
        }
        showPermission
        exact
        path="/settings/brand-settings"
        component={BrandingSettings}
      />
      <ProtectedRoute
        isAllowed={!!lockedFeatures.PayLinkEnabled && featureFlags.isEnabled}
        showPermission
        exact
        path="/settings/elinx"
        component={ElinxSettingsPage}
      />
      <ProtectedRoute
        isAllowed={!!permissions.ViewSettings && preFundingEnabled}
        showPermission
        exact
        path="/settings/pre-funding"
        component={PreFundingSettings}
      />
    </Switch>
  );
};

export default Routes;
